import React from "react";
import styled from "styled-components";
import { Dense } from "./base/density";

export interface PanelProps extends React.HTMLAttributes<HTMLDivElement> {
	/** 300 (left) or 340 (right). §5. */
	width?: "left" | "right" | "auto";
	children?: React.ReactNode;
}

/**
 * §7's panel anatomy: 20px padding all round, 1px border, 6px radius, scrolls
 * vertically, panel-grey ground.
 *
 * It also sets the **density** for everything inside it. A property panel packs
 * many controls into limited height, so its descendants drop to the 40px compact
 * size (plan Q2, option b) without any call site asking. Forms, modals and
 * full-page views sit outside a Panel and keep the 48px default.
 */
const Panel = React.forwardRef<HTMLDivElement, PanelProps>(
	({ width = "auto", children, ...rest }, ref) => (
		<Dense>
			<Shell ref={ref} $width={width} {...rest}>
				{children}
			</Shell>
		</Dense>
	),
);

Panel.displayName = "Panel";

const Shell = styled.div<{ $width: "left" | "right" | "auto" }>`
	display: flex;
	flex-direction: column;
	flex: none;
	width: ${({ $width }) => {
		if ($width === "left") return "var(--size-sidebar-left)";
		if ($width === "right") return "var(--size-sidebar-right)";
		return "auto";
	}};
	padding: var(--space-panel-inset);
	border: var(--border-default);
	border-radius: var(--radius-md);
	background: var(--color-bg-panel);
	box-shadow: none;
	overflow-y: auto;
	overflow-x: hidden;
`;

export default Panel;
